// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__jUUY3","primary":"Divider_primary__TtLrx","secondary":"Divider_secondary__IWgIk","gray":"Divider_gray__8ivQA"};